import React from 'react';

import mapNumberToDisplay from '../../../utils/mapNumberToDisplay';
import searchNumbers from '../../../utils/searchNumbers';
import { isArray } from '../../../utils/isDefined';
import CopyToClipbaordTooltip from '../../../partials/copyToClipbaordTooltip/CopyToClipbaordTooltip';
import { searchInAllNumbers } from './tableColumns';
import { FILTER_CELL_STYLE_RIGHT_ALIGNED } from '../../../consts/tableOptions';
import ConnectActionButtons from './ConnectActionButtons';

export default function tableColumns() {
  const columns = [
    {
      render: rowData => <ConnectActionButtons numberRange={rowData} />,
      disableClick: true,
      sorting: false,
      width: '40px'
    },
    {
      title: 'TABLE.RANGE_FROM',
      render: rowData => (
        <CopyToClipbaordTooltip value={mapNumberToDisplay(rowData.range_from)}>
          {mapNumberToDisplay(rowData.range_from)}
        </CopyToClipbaordTooltip>
      ),
      exportTransformer: rowData => mapNumberToDisplay(rowData.range_from),
      customFilterAndSearch: (term, rowData) => {
        return searchInAllNumbers({
          from: Number(rowData.range_from),
          to: Number(rowData.range_up_to_incl),
          term
        });
      },
      field: 'range_from',
      align: 'right'
    },
    {
      title: 'TABLE.RANGE_TO',
      render: rowData => (
        <CopyToClipbaordTooltip
          value={mapNumberToDisplay(rowData.range_up_to_incl)}
          isPhoneNumber={true}
        >
          {mapNumberToDisplay(rowData.range_up_to_incl)}
        </CopyToClipbaordTooltip>
      ),
      exportTransformer: rowData =>
        mapNumberToDisplay(rowData.range_up_to_incl),
      customFilterAndSearch: (term, rowData) => {
        return searchNumbers(rowData.range_up_to_incl, term);
      },
      field: 'range_up_to_incl',
      align: 'right'
    },
    {
      title: 'ASSIGNED',
      field: 'assigned',
      render: rowData =>
        isArray(rowData.assigned) ? rowData.assigned.length : 0,
      align: 'right',
      customFilterAndSearch: (term, rowData) => {
        return searchNumbers(
          isArray(rowData.assigned) ? rowData.assigned.length : 0,
          term
        );
      },
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    },
    {
      title: 'UNASSIGNED',
      field: 'unassigned',
      render: rowData =>
        isArray(rowData.unassigned) ? rowData.unassigned.length : 0,
      align: 'right',
      customFilterAndSearch: (term, rowData) => {
        return searchNumbers(
          isArray(rowData.unassigned) ? rowData.unassigned.length : 0,
          term
        );
      },
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    }
  ];

  let mappedColumns = [...columns];

  return mappedColumns.map((column, i) => {
    return { ...column, id: i };
  });
}
